'use strict';
module.exports = 9007199254740991;



//////////////////
// WEBPACK FOOTER
// ./node_modules/max-safe-integer/index.js
// module id = 24
// module chunks = 0